import { Component, OnInit } from '@angular/core';
import { PopulationQuery, TransactionType } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-activity-page',
  templateUrl: './activity-page.component.html',
  styleUrls: ['./activity-page.component.scss'],
})
export class ActivityPageComponent implements OnInit {
  population = Populations;
  isKid: boolean;
  transactionTypes = TransactionType;

  constructor(private populationQuery: PopulationQuery) {}

  ngOnInit() {
    this.isKid = this.populationQuery.userInPopulation(['Kids']);
  }
}
